export const RoutesUrl = {
    home: '/',
    about: '/about',
    projects: '/projects',
    contacts: '/contacts',
};
